import { Close } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { FeedbackDetail, FeedbackHeader } from "components/Feedback";
import { FC } from "react";
import { FeedbackType } from "types/feedback";

type FeedbackRequestDetailProps = {
  feedback: FeedbackType;
  open: boolean;
  onClose: () => void;
};

export const FeedbackRequestDetail: FC<FeedbackRequestDetailProps> = ({
  open,
  onClose,
  feedback,
}) => {
  return (
    <Drawer
      anchor={"right"}
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100vw", md: "80%" },
          maxWidth: "760px",
        },
      }}
    >
      <Box px={4}>
        <Box sx={{ position: "absolute", top: "16px", right: "16px" }}>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <Stack
          direction="row"
          alignItems="center"
          sx={{ maxWidth: "calc(100% - 40px)" }}
        >
          <Typography variant="h5" sx={{ padding: "20px" }}>
            Feedback from {feedback.student?.name}
          </Typography>
          <Avatar />
        </Stack>
        <Box mb={2}>
          <FeedbackHeader feedback={feedback} />
        </Box>

        <FeedbackDetail feedback={feedback} />
      </Box>
    </Drawer>
  );
};
